module.exports = __webpack_public_path__ + "img/Estest_Horizontal_white_resize.2b00b7ed.png";